import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const fleetcompletehubConfig: TSPConfig = {
  key: 'fleetcompletehub',
  name: 'Fleet Complete Hub',
  category: TSPCategory.CUSTOM,
  helpText:
    'Note: If you have not transitioned to Fleet Complete Hub, please choose Fleet Complete Web. ' +
    'Input the username and password you use to log into Fleet Complete Hub.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default fleetcompletehubConfig;
